import { render, staticRenderFns } from "./TipoContrato.vue?vue&type=template&id=4544f92c&scoped=true"
import script from "./TipoContrato.vue?vue&type=script&lang=js"
export * from "./TipoContrato.vue?vue&type=script&lang=js"
import style0 from "./TipoContrato.vue?vue&type=style&index=0&id=4544f92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544f92c",
  null
  
)

export default component.exports